import TimingResultsTable from './timing-results-table';

export default TimingResultsTable;